export default __webpack_public_path__ + "static/media/3132 cutlery side.10f81e36.png";